/**
 * Encode an object as a JSON stringified `Uint8Array`
 */
export const dataToUint8Array = <T>(data: T): Uint8Array => {
  const textEncoder = new TextEncoder();
  return textEncoder.encode(JSON.stringify(data));
};

/**
 * Decode and JSON Parse an object from a `UInt8Array`
 */
export const uint8ArrayToData = <T>(data: Uint8Array): T =>
  JSON.parse(new TextDecoder('utf-8').decode(data)) as T;
